// eslint-disable-next-line import/no-relative-packages -- Relative import is required for load Prisma Client
import { PrismaClient } from '../.prisma/client';
import './env';

// eslint-disable-next-line import/no-relative-packages -- Relative import is required for load Prisma Client
export * from '../.prisma/client';
export * from './types';

// Slow log https://github.com/prisma/prisma/issues/5026#issuecomment-1159837097
export const db = new PrismaClient();

export async function ping(): Promise<boolean> {
  let dbAlive;

  try {
    await db.$connect();
    await db.$queryRaw`SELECT 1`;
    dbAlive = true;
  } catch (error) {
    dbAlive = false;
  }

  return dbAlive;
}
